<template>
  <div class="px-0 mx-0" style="width: fit-content">
    <v-avatar v-if="this.imgUrl" :size="aSize && aSize.size ? aSize.size : ''">
      <img style="width: 150%" :src="this.imgUrl" alt="John" />
      <v-tooltip activator="parent" location="start">
        <span class="avatarTip">{{
          this.fName && this.lName
          ? `${this.fName} ${this.lName}`
          : this.fName && !this.lName
            ? `${this.fName}`
            : ""
        }}</span>
      </v-tooltip>
    </v-avatar>

    <v-avatar
      v-else
      :style="{ 'background-color': avatarColor, 'box-shadow': `0 2px 8px ${avatarColor}55` }"
      :class="type == 'account' ? 'accountAvatar' : ''"
      :size="aSize && aSize.size ? aSize.size : ''"
    >
      <span
        v-if="acCode"
        :style="{ 'font-size': aSize && aSize.font ? aSize.font : '' }"
        style="color: white; text-transform: uppercase; font-weight: 700; letter-spacing: 0.5px;"
      >{{ this.acCode ? `${this.acCode}` : "" }}</span>
      <span
        v-else
        :style="{ 'font-size': aSize && aSize.font ? aSize.font : '' }"
        style="color: white; text-transform: uppercase; font-weight: 700; letter-spacing: 0.5px;"
      >{{
        this.fName && this.lName
        ? `${this.fName[0]}${this.lName[0]}`
        : this.fName && !this.lName
          ? `${this.fName[0]}${this.fName[1] || ''}`
          : ""
      }}</span>
      <v-tooltip activator="parent" v-if="fName" location="start">
        <span class="avatarTip">{{
          this.fName && this.lName
          ? `${this.fName} ${this.lName}`
          : this.fName && !this.lName
            ? `${this.fName}`
            : ""
        }}</span>
      </v-tooltip>
    </v-avatar>
  </div>
</template>
<script>
import commonService from "@/common.service";
export default {
  props: ["size", "fName", "lName", "imgUrl", "theme", "type", 'acCode', 'arounded'],
  data() {
    return {
      userData: null,
      url: null,
      aSize: null,
      aType: ''
    };
  },
  computed: {
    avatarColor() {
      // If a theme color is explicitly provided, use it
      if (this.theme) return this.theme;
      // Otherwise derive a consistent brand-palette color from the name
      const palette = [
        '#3C5AAA', // brand primary
        '#2d4490', // brand dark
        '#4f6bbf', // brand mid
        '#5c7fd4', // brand light
        '#3a6186', // steel blue
        '#2e5fa3', // cobalt
        '#1a4a8a', // deep blue
        '#4a6fa5', // slate blue
        '#3d5a80', // ocean
        '#2c4a7c', // navy
      ];
      const seed = this.fName || this.acCode || '';
      let hash = 0;
      for (let i = 0; i < seed.length; i++) {
        hash = seed.charCodeAt(i) + ((hash << 5) - hash);
      }
      return palette[Math.abs(hash) % palette.length];
    },
  },
  watch: {
    type() {
      if (this.type) {
        this.aType = this.type
      }
    }
  },
  created() {
    if (this.size) {
      this.getSize();
    }
  },
  methods: {
    getSize() {
      if (this.size == "xSmall") {
        this.aSize = commonService.xSmallAvatar();
      }
      if (this.size == "coustom") {
        this.aSize = commonService.coustomAvatar();
      }
      if (this.size == "small") {
        this.aSize = commonService.smallAvatar();
      }
      if (this.size == "medium") {
        this.aSize = commonService.mediumAvatar();
      }
      if (this.size == "large") {
        this.aSize = commonService.largeAvatar();
      }
    },
  },
};
</script>
<style>
.avatarTip {
  text-transform: capitalize;
}

.accountAvatar {
  scale: .75;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  border-radius: 8% !important;
}
</style>